import { render, staticRenderFns } from "./PromotionsSitewideDesktop.vue?vue&type=template&id=43863666&scoped=true"
import script from "./PromotionsSitewideDesktop.vue?vue&type=script&lang=js"
export * from "./PromotionsSitewideDesktop.vue?vue&type=script&lang=js"
import style0 from "./PromotionsSitewideDesktop.vue?vue&type=style&index=0&id=43863666&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43863666",
  null
  
)

export default component.exports